import { createFileRoute } from '@tanstack/react-router';
import { PayoutInfo } from '@/features/cleaner/payout-info';

export const Route = createFileRoute(
  '/(cleaner)/_authenticated/cleaner/payout'
)({
  component: PayoutInfo,
});
